import React from "react";

import Price from "@atoms/Price";

interface IProps {
  autoDiscountAmount?: number;
  codeDiscountAmount?: number;
  codeDiscountTitle: string;
  autoDiscountTitle: string;
}

export default function Discounts({
  autoDiscountAmount = 0,
  codeDiscountAmount = 0,
  codeDiscountTitle,
  autoDiscountTitle,
}: IProps) {
  return (
    <>
      {autoDiscountAmount + codeDiscountAmount > 0 && (
        <>
          <div className="-mb-1 flex justify-between">
            <span className="uppercase">Discount</span>
            <Price isNegative price={autoDiscountAmount + codeDiscountAmount} />
          </div>

          {autoDiscountAmount > 0 && (
            <div className="flex justify-between text-xs font-normal">
              <span>({autoDiscountTitle})</span>
              <Price className="shrink-0" isNegative price={autoDiscountAmount} />
            </div>
          )}

          {codeDiscountAmount > 0 && (
            <div className="-mt-1 flex justify-between text-xs font-normal">
              <span>({codeDiscountTitle})</span>
              <Price isNegative price={codeDiscountAmount} />
            </div>
          )}
        </>
      )}
    </>
  );
}
